export default __webpack_public_path__ + "static/media/layout-1.f17c992e.jpg";